import { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getActiveResult } from '../redux/selectors';
import cx from 'classnames';

function removeAllChildNodes(parent) {
    while (parent.firstChild) {
        parent.removeChild(parent.firstChild);
    }
}
export default function Result(props){
	const dispatch = useDispatch();
	const activeResult = useSelector( getActiveResult );
	const resultRef = useRef(null);
	useEffect( () => {
		if ( resultRef.current ){
			removeAllChildNodes(resultRef.current);
			if ( activeResult ){
				if ( activeResult.element ){
					resultRef.current.append(activeResult.element);
				} else {
					resultRef.current.innerHTML = 'Result element not found';
				}
			} else {
				resultRef.current.innerHTML = 'No result'
			}
		}
		return () => {
			// removeAllChildNodes( resultRef.current );
		}
	}, [resultRef.current, activeResult]);
	useEffect( () => {
		if ( activeResult ){
			window.jQuery(window).trigger('resized-w');
		}
	}, [activeResult] );
	return <div className={ cx(
		"sr-results"
	) } >
		{ !activeResult &&
		<div className="no-result">
			No results to show
		</div>
		}
		{ activeResult &&
		<div className="sr-result" ref={ resultRef } >

		</div>
		}
	</div>
}